<template>
  <span>
    <span v-for="(l, x) in langs" :key="x">
      <img 
        @click="setLang(l.id)"
        :src="`/assets/images/flags/${l.id}.jpg`"
        :alt="`${l.label}'s Flag`"
        :title="`${l.label}`"
        :class="{'selected': l.id === lang.id}" />
    </span>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LanguageBar",
  components: {  },
  methods: {
    ...mapActions("languages", ["setLang"])
  },
  computed: {
    ...mapGetters("languages", ["lang", "langs"])
  }
};
</script>

<style lang="scss" scoped>
  img {
    margin-right: 5px;
    width: 19.5px;
    height: 12.5px;
    cursor: pointer;
  }
  img.selected {
    opacity: 0.5;
    border: 1px solid white;
    cursor: default;
  }
</style>
